export default {
  dataIterator: {
    rowsPerPageText: '페이지당 항목:',
    rowsPerPageAll: '전체',
    pageText: '{0}-{1} / {2}',
    noResultsText: '일치하는 기록을 찾을 수 없습니다',
    nextPage: '다음 페이지',
    prevPage: '이전 페이지'
  },
  dataTable: {
    rowsPerPageText: '페이지당 행:'
  },
  noDataText: '사용 가능한 데이터가 없습니다',
  carousel: {
    prev: '이전 이미지',
    next: '다음 이미지'
  },
  errors: {
    codeIncorrect: '코드가 올바르지 않습니다.',
    errorLogin: '로그인 오류',
    qr: {
      notAllowed: '오류: 카메라 접근 권한을 부여해야 합니다',
      notFound: '오류: 이 장치에는 카메라가 없습니다',
      notSupported: '오류: 보안 컨텍스트 필요(HTTPS, localhost)',
      notReadable: '오류: 카메라가 이미 사용 중입니까?',
      overConstrained: '오류: 설치된 카메라가 적합하지 않습니다',
      streamAPINotSupported: '오류: 이 브라우저에서 스트림 API를 지원하지 않습니다',
      scanFailed: '유효하지 않은 QR 코드',
      tableNumberFailed: '유효하지 않은 테이블 번호'
    },
    location: {
      inStoreTitle: '현재 위치가 매장 내부가 아닙니다',
      inStoreDescription: '매장 내 주문을 할 수 없습니다. 픽업 또는 배달을 선택해 주세요',
      inStoreBtn: '확인',
      locationDisabledTitle: 'GPS 위치를 허용해 주세요',
      locationDescription: 'QR 코드를 다시 스캔하고 GPS 위치를 허용하거나, 휴대폰 설정에서 직접 활성화해 주세요',
      locationBtn: '확인'
    },
    cart: {
      menuUnavailable: '이 시간에는 메뉴를 이용할 수 없습니다',
      startShopping: '주문 시작'
    },
    schedule: {
      availableTimes: '{0}은 {1} - {2}에만 이용 가능합니다',
      unavailableTimes: '{0}은 {1} - {2}에 이용할 수 없습니다',
      availableDay: '{0}은 {1} {2}에 이용 가능합니다',
      unavailable: '{0}은 현재 이용할 수 없습니다. 다른 주문 유형을 시도해 주세요',
      startScheduling: '{0} {1}부터 주문 예약을 시작할 수 있습니다'
    },
    paymentUnsuccessful: '결제 실패',
    temporarilyAppear: '이 요금은 제거되기 전에 임시로 명세서에 표시될 수 있습니다',
    pageNotFound: '페이지를 찾을 수 없습니다',
    storeNotFoundMessage: '찾고 있는 매장을 찾을 수 없습니다. 매장이 이동했거나 삭제되었거나 URL이 올바르지 않을 수 있습니다.'
  },
  common: {
    storeHoursClosedHoliday: "닫힘",
    today: '오늘',
    nextAvailable: '다음 이용 가능',
    referralButtonText: '친구 초대하기',
    pointsEarned: '적립된 포인트',
    confirmTitle: '확인해 주세요',
    confirmDesc: '매장 내 주문에서 전환하시겠습니까?',
    actionText: '예, 전환합니다',
    pickup: '픽업',
    delivery: '배달',
    availableToDeliver: '배달 가능',
    notAvailableForDelivery: '배달 불가',
    loginDescription: '지금 가입하거나 로그인하여 독점 쿠폰, 보상 및 맞춤형 혜택을 확인하세요!',
    orderNow: '지금 주문',
    hours: '영업 시간',
    location: '위치',
    contact: '연락처 정보',
    socials: "소셜 미디어",
    snappyWhy: 'Snappy를 선택하는 이유',
    snappyBlog: '블로그',
    snappyPricing: '요금',
    snappyDemo: '데모 예약',
    snappyCaseStudies: '고객 사례',
    clickToRedeem: '클릭하여 사용',
    apply: '적용',
    order: '주문',
    sortByDistance: '거리순 정렬',
    sortByAlpha: '알파벳순 정렬',
    searchLocations: '위치 검색',
    az: '가나다',
    nearest: '가까운 순',
    atLeast: '최소',
    to: '부터',
    takeout: '포장',
    or: '또는',
    guest: '손님',
    back: '뒤로',
    other: '기타',
    groups: '그룹',
    options: '옵션',
    edit: '편집',
    register: '가입',
    poweredBy: '제공자',
    firstName: '이름',
    lastName: '성',
    phone: '전화',
    phoneNumber: '전화번호',
    address: '주소',
    storeHours: '영업시간',
    onlineOrderAvailableUntil: '온라인 주문 가능 시간',
    mobileNumber: '휴대전화 번호',
    status: '상태',
    points: '포인트',
    balance: '잔액',
    save: '저장',
    changesSaved: '변경 사항이 저장되었습니다',
    cancel: '취소',
    confirm: '확인',
    message: '메시지',
    loadMore: '더 보기',
    loading: '로딩 중...',
    expires: '만료일',
    login: '로그인 / 가입',
    tweet: '트윗',
    share: '공유',
    continue: '계속',
    resend: '(다시 보내기: {0})',
    newCode: '새 코드',
    logout: '로그아웃',
    fillFields: '필수 필드를 모두 입력해 주세요',
    invalidEmail: '유효하지 않은 이메일',
    verify: '인증',
    verifyCode: '코드 인증',
    sixDigitCode: '6자리 코드',
    unlimited: '무제한',
    upTo: '최대',
    selected: '선택됨',
    items: '항목',
    amount: '금액',
    scanQRCode: '매장 내 QR 코드 스캔',
    loadingQRScanner: '스캐너 로딩 중...',
    reloadQRScanner: '다시 로드',
    open: '열기',
    open2: '열림',
    closed: '닫힘',
    closed2: '닫힘',
    email: '이메일',
    select: '선택',
    ok: '확인',
    okConfirm: '확인',
    off: '꺼짐',
    app: {
      text1: '다음에서 열기',
      text2: '앱',
      btn: '열기'
    },
    captcha: {
      main: '이 사이트는 reCAPTCHA 및 Google',
      privacy: '개인정보 처리방침',
      and: '과',
      terms: '서비스 약관',
      apply: '의 적용을 받습니다.'
    },
    disclaimer: {
      main: '로그인함으로써 <link-tos>서비스 약관</link-tos> 및 <link-pp>개인정보 처리방침</link-pp>에 동의합니다. 또한 {businessName}로부터 쿠폰, 특별 제안, 프로모션을 포함한 SMS 메시지 및 기타 디지털 커뮤니케이션을 수신하는 데 동의합니다. 표준 메시지 및 데이터 요금이 적용될 수 있습니다.',
      register: 'REGISTER를 클릭하면 Snappy의 <link-tos>서비스 약관</link-tos> 및 <link-pp>개인정보 처리방침</link-pp>에 동의하는 것입니다. Snappy는 귀하의 계정을 보호하고 알림을 보내기 위해 SMS 정보를 사용합니다. 언제든지 SMS 메시지를 거부할 수 있습니다.'
    },
    addedToCart: '"{0}"이(가) 장바구니에 추가되었습니다',
    yourOrderId: '귀하의 주문 ID는'
  },
  hours: {
    twentyFourHours: '24시간 영업',
    midNight: '자정',
    mon: '월',
    tues: '화',
    wed: '수',
    thurs: '목',
    fri: '금',
    sat: '토',
    sun: '일',
    monday: '월요일',
    tuesday: '화요일',
    wednesday: '수요일',
    thursday: '목요일',
    friday: '금요일',
    saturday: '토요일',
    sunday: '일요일'
  },
  menu: {
    specialRequests: '특별 지시사항',
    required: '필수',
    optional: '선택 사항',
    soldOut: '품절',
    selectMenu: '메뉴를 선택해 주세요',
    menuTitle: '메뉴',
    promotionsAndRewards: '프로모션 및 리워드',
    categories: '카테고리',
    noMenu: '매장에서 찾을 수 있는 메뉴가 없습니다',
    dropdown: '메뉴 드롭다운',
    unavailable: '메뉴를 이용할 수 없습니다',
    available: '이용 가능 시간',
    dayAvailable: '다음 이용 가능',
    availableOffHours: '이 메뉴는 예약 주문에 이용 가능합니다',
    menuIsExclusive: '다른 메뉴의 항목은 동일한 장바구니에 추가할 수 없습니다',
    item: {
      onlyAvailable: '이용 가능',
      available: '이 항목은 {0} - {1}에만 이용 가능합니다',
      prepTime: '이 항목은 준비하는 데 약 {0} 소요됩니다'
    },
    menuAvailability: '메뉴 이용 가능 여부',
    gotIt: "알겠습니다!",
    onlyAvailable: '이 메뉴는 특정 시간에만 이용 가능합니다:',
    pricingBanner: '{2}에서 직접 주문하고 {1} 대비 평균 최대 {0}%까지 절약하세요'
  },
  cart: {
    title: '장바구니',
    startShopping: '쇼핑 시작하기',
    continue: '계속하기',
    serviceFee: '서비스 요금',
    takeOutOrder: '포장 주문',
    backToLogin: '로그인으로 돌아가기',
    enterYourAddress: '주소를 입력해 주세요',
    startAdding: '주문을 작성하기 위해 메뉴에서 항목을 추가하세요.',
    buildOrder: '주문을 계속 작성하려면 새 항목을 추가하세요',
    currentlyClosed: '현재 영업하지 않습니다. 적절한 시간에 다시 방문해 주세요.',
    delivery: '배달',
    pickup: '픽업',
    dinein: '매장 식사',
    estTimeHours: '시간',
    estTimeMins: '분',
    subtotal: '소계',
    deliveryFee: '배달료',
    tbd: '미정',
    deliveryMinimum: '배달 최소 주문 금액',
    pickupMinimum: '픽업 최소 주문 금액',
    tax: '세금',
    tip: '팁',
    tipDriver: '기사에게 팁 주기',
    tipStore: '팁으로 매장을 지원하세요',
    rewards: '보상',
    total: '총계',
    btnCheckout: '결제하기',
    addToCart: '장바구니에 추가',
    aiRecommendationsTitle: '맞춤 추천',
    aiRecommendationsTitleGuest: '추천',
    aiRecommendationsSubtitle: '주문 내역 기반',
    aiRecommendationsSubtitleGuest: '이 매장의 인기 메뉴',
    aiRecommendationsFrom: '부터',
    saveCartItem: '장바구니 업데이트',
    clickToSee: '옵션을 보려면 클릭하세요',
    payWithMembership: '멤버십으로 결제',
    btnSubmitSubOrder: '주문 제출',
    processing: '주문 처리 중',
    pastOrders: '과거 주문',
    discount: '할인',
    btnPayOrder: '주문 제출',
    closeModal: '닫기',
    cartUnavailable: '이용 가능 시간과 충돌하거나 유효하지 않아 주문할 수 없는 항목이 장바구니에 있습니다',
    storeUnavailable: '현재 이용할 수 없습니다',
    storeClosedBtn: '매장 영업 종료',
    offHourOrderingMaybeAllowed: '매장이 현재 영업을 종료했습니다. 그러나 나중에 주문을 예약할 수 있습니다.',
    advanceBookingWindow: '매장은 영업 중이나 아직 주문을 받지 않습니다. 나중에 주문을 예약할 수 있습니다.',
    deliveryUnavailable: '현재 배달을 이용할 수 없습니다',
    pickupUnavailable: '현재 픽업을 이용할 수 없습니다',
    tooSmallForDelivery: '배달에 대한 주문 금액이 너무 적습니다 (최소: {0})',
    tooSmallForPickup: '픽업에 대한 주문 금액이 너무 적습니다 (최소: {0})',
    invalidCoupon: '유효하지 않은 쿠폰',
    cartErrors: '장바구니 오류',
    removeInvalidItemToContinue: '계속하려면 삭제해 주세요.',
    discountNotUsed: '장바구니가 비어 있으면 안 됩니다',
    deliveryDisabled: '배달이 일시적으로 판매자에 의해 비활성화되었습니다',
    pickupDisabled: '픽업이 일시적으로 판매자에 의해 비활성화되었습니다',
    deliveryDisabledUntil: '배달이 일시적으로 판매자에 의해<br>{0}까지 비활성화되었습니다',
    pickupDisabledUntil: '픽업이 일시적으로 판매자에 의해<br>{0}까지 비활성화되었습니다',
    asapClosed: '영업 종료 · {0} {1}에 오픈',
    asapPastCutoff: '오늘은 더 이상 주문을 받지 않습니다',
    asapSuspendedToday: '오늘은 더 이상 주문을 받지 않습니다',
    storeStoppedAcceptingOrders: '결제를 진행하는 동안 매장이 주문 접수를 중단했습니다. 계속하려면 예약 시간을 선택하세요.'
  },
  account: {
    accountInfo: '계정 정보',
    orderHistory: '주문 내역',
    paymentMethods: '결제 수단',
    contactInfo: '연락처 정보',
    membershipInfo: '멤버십 정보',
    member: '멤버',
    nonMember: '비멤버',
    creditCard: '신용카드',
    nameOnCard: '카드상의 이름',
    cardNumber: '카드 번호',
    expires: '유효기간',
    cvc: 'CVC',
    mmyy: 'MM / YY',
    country: '청구 국가',
    saveCard: '카드 저장',
    addPaymentMethod: '결제 수단 추가',
    deliveryDetails: '배달 세부 정보',
    noOrderHistory: '주문 내역이 없습니다',
    noPaymentMethods: '결제 수단이 없습니다',
    addPaymentMethodPrompt: '결제 수단을 추가해 주세요',
    noCreditCards: '결제 수단이 없습니다',
    otherPostalCode: '미국 또는 캐나다 이외의 카드는 아무 숫자나 입력해 주세요',
    membership: '멤버십',
    history: '내역',
    payments: '결제',
    offline: '현장 결제',
    orderId: '주문 ID',
    editTitle: '개인 정보 편집',
    payment: {
      title: '결제 수단 삭제',
      body: '이 결제 수단을 삭제하시겠습니까?',
      cancel: '취소',
      delete: '삭제',
      status: {
        cvcFailed: '유효하지 않은 CVC',
        postalCodeFailed: '우편번호가 올바르지 않습니다',
        expiredCard: '카드 만료'
      }
    },
    rewards: {
      redeemFor: '상환 대상',
      rewardOptions: '보상 옵션',
      coupons: '쿠폰',
      punchCards: '펀치 카드',
      using: '사용 중',
      remaining: '남은 횟수',
      free: '무료',
      purchases: '구매',
      redeem: '사용',
      max: '최대',
      points: '포인트',
      credits: '크레딧',
      discount: '할인',
      yourPoints: '귀하의 포인트',
      creditsEarned: '{0} 적립됨',
      worth: '가치',
      insufficientFunds: '포인트 부족',
      removeFirst: '활성화된 보상 옵션을 제거해 주세요',
      punchCardRibbon: '{0}개의 {1}을(를) 더 구매하면 {2}!',
      selectItem: '항목 선택',
      availableInCart: '사용 가능한 보상은 장바구니에 표시됩니다',
      availableInCartUpdated: '장바구니에서 이 혜택을 사용하세요',
      alreadyInCart: '"{0}"은(는) 이미 장바구니에 있습니다',
      missingPoints: '이 펀치 카드를 사용하려면 {0} 포인트가 더 필요합니다!',
      inEligible: '이 쿠폰을 사용할 자격이 없습니다',
      noExpiration: '만료 없음',
      noLimitation: '제한 없음',
      buy1Get1Free: '1+1 무료',
      buy1Get1PercentOff: '1+1 두 번째 {0}% 할인',
      buy1Get1AmountOff: '1+1 두 번째 ${0} 할인',
      validForSelectItems: '특정 상품에 유효',
      discountPercentOff: '{0}% 할인',
      discountAmountOff: '{0}{1} 할인',
      discountOff: '{0} 할인',
      discountUpTo: '{0}, 최대 {1}',
      maxDiscountReached: '최대 할인 금액 {0}에 도달했습니다',
      maxDiscountOf: '최대 {0}',
      maxDiscountOfDetail: '최대 할인 금액 {0}',
      offerExpires: '혜택 만료: {0}',
      loginPrompt: '보상을 보려면 로그인해 주세요',
      inPersonRedeemable: '이 보상은 매장에서만 사용할 수 있습니다',
      orderRewards: {
        congrats: '축하합니다!',
        coupons: '주문으로 보너스 쿠폰을 받았습니다',
        lossFallback: '죄송합니다. 이번에는 당첨되지 않았습니다. 다음 주문에서 다시 시도해 주세요!'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: '맞춤 추천',
    aiRecommendationsCategoryGuest: '추천',
    deliveryProvider: {
      robot: '로봇',
      human: '배달원',
      byRobot: '외부에서 로봇 만나기',
      byHuman: '문 앞에서 배달원 만나기',
      recommended: '이 업체에서 추천',
      notSupported: '{0} 배달은 귀하의 주소에서 지원되지 않습니다',
      deliveryInstructions: '로봇은 계단을 오를 수 없습니다. 음식을 받으려면 이메일로 받은 코드를 제공해야 합니다'
    },
    error: {
      empty: '여기에 표시할 것이 없습니다!',
      noResults: '결과가 없습니다.',
      tryAdjusting: '필터를 조정해 보세요',
      clear: '검색 지우기'
    }
  },
  order: {
    estimatedTime: '주문이 성공적으로 접수되었습니다. {0}에 픽업 준비가 완료됩니다',
    estimatedTimeDiff: '주문이 성공적으로 접수되었습니다. 약 {0} 후에 픽업 준비가 완료됩니다',
    successfulOrder: '주문이 성공적으로 접수되었습니다',
    deliveryAddressInvalid: '입력한 주소가 유효하지 않습니다. 다시 시도해 주세요',
    deliveryAddressMustBeSet: '배달 주소를 설정해야 합니다',
    deliveryAddressMustBeInRange: '죄송합니다. 귀하의 주소는 배달 가능 범위 내에 있지 않습니다. 주문을 하려면 매장에 문의해 주세요',
    noPaymentMethodSelected: '결제 수단을 선택해 주세요',
    insufficientPoints: '멤버십 잔액 부족',
    requiresAdditionalMethod: '잔액 부족, 두 번째 결제 수단 필요',
    cardMinimumCharge: '카드로 최소 {0} 이상 결제해야 합니다. 팁이나 다른 상품을 추가하거나 이 주문을 카드로 결제하세요.',
    minCardChargeNote: '최소 카드 결제 금액 {0}',
    applyMembershipInstead: '대신 {0} 적용',
    noPaymentMethods: '결제 수단을 선택해 주세요',
    pickUpDetails: '픽업 세부 정보',
    orderDetails: '주문 세부 정보',
    selectOrderType: '주문 유형 선택',
    orderPlaced: '주문 접수',
    orderScheduled: '예약 시간',
    orderNotes: '주문 메모',
    pickUpTime: '픽업 시간',
    pickUpDay: '픽업 날짜',
    deliveryTime: '배달 시간',
    deliveryDay: '배달 날짜',
    deliveryAddress: '배달 주소',
    addressLine1: '주소 1',
    addressLine2: '주소 2',
    postalCode: '우편번호',
    city: '도시',
    payment: '결제',
    placeOrder: '주문하기',
    personalDetails: '개인 정보',
    tableNumberSet: '테이블이 설정되었습니다.',
    onlyOffline: '이 매장은 현장 결제만 가능합니다.',
    paidOffline: '주문은 현장에서 결제됩니다',
    emailReceipt: '영수증을 이메일로 보내기',
    offlineEmailReceipt: '주문 확인을 이메일로 보내기',
    status: {
      new: '새 주문',
      inProgress: '진행 중',
      ready: '준비 완료',
      cancelled: '취소됨',
      refunded: '환불됨',
      completed: '완료됨'
    },
    orderActions: {
      call: '전화',
      direction: '길찾기',
      orders: '주문 보기',
      feedbackTitle: '주문에 대한 피드백을 제공해 주세요',
      feedbackLabel: '피드백 제공'
    }
  },
  iosBanner: {
    partOne: '공유 아이콘을 클릭하고',
    partTwo: '홈 화면에 추가를 선택하여',
    partThree: '설치하세요'
  },
  checkoutSuccess: {
    text: '결제 성공'
  },
  orderSubmitted: {
    text: '주문이 제출되었습니다'
  },
  deliveryDialog: {
    title: '배달 상세정보',
    deliverAsap: '즉시 배달',
    schedule: '일정',
    update: '업데이트',
    selectAddress: '주소를 입력해주세요',
    noDeliveryProviders: '해당 주소로 배달 가능한 업체가 없습니다',
    deliveryAddressSet: '배달 주소가 설정되었습니다!',
    selectDateTime: '유효한 날짜와 시간을 선택해주세요',
    notAvailable: '죄송합니다. 이용할 수 없습니다',
    pleaseSelectDate: '날짜를 선택해주세요'
  },
  orderDialog: {
    title: '픽업 상세정보',
    deliveryTitle: '배달 상세정보',
    pickUpAsap: '즉시 픽업',
    deliverAsap: '즉시 배달',
    schedule: '일정',
    done: '완료',
    selectDate: '날짜를 선택해주세요',
    notAvailable: '죄송합니다. 이용할 수 없습니다',
    selectDateTime: '유효한 날짜와 시간을 선택해주세요',
    noAvailableDays: "이용 가능한 날짜가 없습니다",
    earliestDate: "가장 빠른 날짜가 설정되었습니다",
    staleTimeBodyGroup: "매장에서 {0}까지 주문을 준비할 수 없습니다. 계속하려면 새 시간을 선택하세요 — 그룹 및 게스트의 항목은 변경되지 않습니다.",
    staleTimeBodySolo: "매장에서 {0}까지 주문을 준비할 수 없습니다. 계속하려면 새 시간을 선택하세요.",
    confirmSlot: "{0} 확인",
    goBack: "뒤로 가기"
  },
  storeLocation: {
    pickUpAt: '픽업',
    inStore: '매장 내',
    pickUpTime: '픽업 시간',
    deliveryTime: '배달 시간',
    time: '시간',
    deliverTo: '배달 주소',
    clickToSet: '설정하려면 클릭'
  },
  orderTypes: {
    pickup: '픽업',
    delivery: '배달',
    dineIn: '매장 식사'
  },
  groupOrder: {
    title: '단체 주문',
    namePlaceholder: '단체 주문 이름',
    from: '출발지',
    deliverTo: '배달 주소',
    pickupAt: '픽업 장소',
    invitePeople: '멤버 초대',
    chooseWhoPays: '결제 방식 선택',
    paySubtitle: '주최자(귀하)가 전체 단체 주문 금액을 결제합니다. 결제 수단은 체크아웃 시 입력됩니다.',
    youPayForEveryone: '전원 대신 결제',
    hostWillPayForEveryone: '호스트가 모두를 위해 결제합니다',
    limitPlaceholder: '1인당 한도 입력 (선택 사항)',
    perPerson: '1인당',
    everyonePaysThemselves: '각자 결제',
    comingSoon: '출시 예정',
    next: '다음',
    yourGroupOrderLink: '단체 주문 링크',
    copy: '복사',
    share: '공유',
    linkCopied: '링크가 복사되었습니다!',
    join: '{0}의 단체 주문 참여',
    spendingLimit: '소비 한도',
    limitNoLimit: '제한 없음',
    limitOther: '직접 입력',
    joinGroupOrder: '단체 주문 참여',
    joining: '참여 중...',
    loginToJoin: '로그인하여 참여',
    continueAsGuest: '게스트로 계속',
    enterYourName: '이름을 입력하세요',
    joinOrderDisclaimer: '주문 참여를 클릭하면 다음에 동의하게 됩니다',
    joinOrder: '주문 참여',
    back: '뒤로',
    notSet: '미설정',
    cancelGroupOrder: '단체 주문 취소',
    cancelGroupOrderConfirmTitle: '{0}을(를) 취소하시겠습니까?',
    cancelGroupOrderConfirmBody: '모든 참여자의 단체 주문이 종료되고 참여자가 제거됩니다.',
    cancelGroupOrderConfirm: '네, 취소합니다',
    cancelGroupOrderKeep: '단체 주문 유지',
    cartMenuCancelGroup: '단체 주문 취소',
    cartMenuLeaveGroup: '나가기',
    cartMenuInvite: '멤버 초대',
    lockedBannerGuest: '이 단체 주문이 잠겼습니다. 변경하려면 주최자에게 문의하세요.',
    lockedBannerHost: '장바구니가 잠겼습니다. 체크아웃을 계속 진행할 수 있습니다.',
    unlockMyCart: '장바구니 잠금 해제',
    othersInGroup: '그룹 내 다른 멤버 ({0}명)',
    othersHaveAdded: '{1}명 중 {0}명이 상품을 추가했습니다',
    memberHostLabel: '(주최자)',
    memberReadyBadge: '준비 완료',
    memberWaitingBadge: '대기 중',
    memberErrorBadge: '품절된 상품',
    memberCartHasErrors: '그룹 내 누군가의 상품이 품절되었습니다. 계속하려면 제거해 주세요.',
    memberNoItems: '아직 상품 없음',
    unlockMemberCart: '{0}의 장바구니 잠금 해제',
    removeMember: '{0} 제거',
    yourItems: '내 상품',
    leaveConfirmTitle: '이 단체 주문에서 나가시겠습니까?',
    leaveConfirmBody: '내 상품이 제거되고 주최자에게 알림이 전송됩니다.',
    leaveConfirmBtn: '나가기',
    leaveConfirmKeep: '취소',
    removeConfirmTitle: '{0}을(를) 단체 주문에서 제거하시겠습니까?',
    removeConfirmBody: '{0}의 상품이 제거되고 주최자에 의해 제거되었다는 알림을 받게 됩니다.',
    removeConfirmBtn: '{0} 제거',
    checkoutConfirmTitle: '모두 준비되셨습니까?',
    checkoutConfirmBody: '계속하면 단체 주문이 잠기고 아무도 변경할 수 없습니다.',
    unreadyConfirmTitleSingle: '{0}님이 아직 주문 중이에요',
    unreadyConfirmTitleMulti: '참여자 {0}명이 아직 주문 중이에요',
    unreadyConfirmBody: '결제하면 모두의 주문이 마감됩니다.',
    unreadyConfirmWaitingOnPrefix: '',
    unreadyConfirmWaitingOnSuffix: '님을 기다리는 중이에요.',
    and: '및',
    andOthers: '외 {0}명',
    checkoutWithCurrentBtn: '장바구니 그대로 결제',
    checkoutWithCurrentSubtext: '지금까지 담은 항목대로 주문이 진행돼요',
    removeCartsCheckoutBtn: '제외하고 결제',
    removeCartsCheckoutSubtext: '해당 참여자의 장바구니와 항목은 주문에서 제외돼요',
    errorRemoveUnreadyCarts: '일부 장바구니를 제거하지 못했습니다. 다시 시도해 주세요.',
    groupCartEmpty: '결제하기 전에 항목을 하나 이상 담아주세요.',
    participantWaiting: '대기 중...',
    notReadyCount: '{0}명의 참여자가 아직 준비되지 않았습니다',
    goToCheckout: '체크아웃으로 이동',
    lockedInGroupOrder: '단체 주문 중입니다 — 주문 유형과 시간을 변경할 수 없습니다.',
    checkoutProcessing: '처리 중...',
    checkoutBackBtn: '뒤로 가기',
    readyBtn: '준비 완료!',
    readyHint: '주최자가 모두를 위해 주문을 진행합니다.',
    readyStatus: '준비 완료!',
    imReadyBtn: '준비됐습니다!',
    addItemsBtn: '상품 추가',
    lockedCheckoutBtn: '단체 주문 잠김',
    lockedTimeoutBtn: '주문 잠김 — 시간 초과',
    exceedsLimit: '단체 주문 한도 초과',
    snackParticipantLeft: '{0}이(가) 단체 주문을 나갔습니다.',
    errorMarkReady: '준비 표시 실패. 다시 시도해 주세요.',
    errorCartLocked: '주최자가 주문을 잠갔습니다. 지금은 변경할 수 없습니다.',
    errorUnlockCart: '장바구니를 잠금 해제할 수 없습니다. 다시 시도해 주세요.',
    errorLockGroup: '단체 주문 잠금 실패. 다시 시도해 주세요.',
    errorLeaveGroup: '단체 주문 나가기 실패. 다시 시도해 주세요.',
    errorCancelGroup: '단체 주문 취소 실패. 다시 시도해 주세요.',
    errorUnlockMember: '장바구니 잠금 해제 실패. 다시 시도해 주세요.',
    errorRemoveParticipant: '참여자 제거 실패. 다시 시도해 주세요.',
    dialogRemovedTitle: '제거되었습니다',
    dialogRemovedBody: '주최자가 이 단체 주문에서 귀하를 제거했습니다. 상품이 모두 삭제되었습니다.',
    dialogLeftTitle: '{0}에서 나갔습니다',
    dialogLeftBody: '상품이 모두 삭제되었습니다.',
    dialogCancelledTitle: '단체 주문 취소됨',
    dialogCancelledBody: '주최자가 이 단체 주문을 취소했습니다.',
    dialogPaidTitle: '주문 완료!',
    dialogPaidBody: '단체 주문이 성공적으로 접수되었습니다.',
    dialogRecoveredTitle: '진행 중인 단체 주문이 있습니다',
    dialogRecoveredHost: '귀하는 주최자입니다',
    dialogRecoveredGuest: '귀하는 참여자입니다',
    dialogRecoveredBtn: '계속',
    deadlineTitle: '마감 시간 설정',
    deadlineSubtitle: '모두가 언제까지 주문해야 하나요?',
    deadlineDayLabel: '주문 마감 (일)',
    deadlineTimeLabel: '주문 마감 (시간)',
    noDeadline: '마감 없음',
    noDeadlineSet: '마감 미설정',
    deadlineSpecificTime: '특정 시간',
    orderDeadline: '주문 마감 시간',
    orderBeforeDeadline: '{0}까지 주문하세요',
    peopleCanOrderAnytime: '언제든지 주문 가능',
    notAvailableScheduled: '이 예약 시간에는 사용 불가',
    deadlineNotAvailableNow: '배달 시간이 지금으로 설정된 경우 마감 시간을 사용할 수 없습니다.',
    noAvailableDeadlineTimes: '마감 시간을 설정할 수 있는 시간이 없습니다. 나중 배달 시간을 선택하세요.',
    noSpendingLimit: '지출 한도 없음',
    spendingLimitValue: '{0} 한도',
    dialogChangedTitle: '호스트가 주문을 업데이트했습니다',
    dialogChangedToDelivery: '배달로 변경됨',
    dialogChangedToPickup: '픽업으로 변경됨',
    dialogChangedTime: '시간이 {0}에서 {1}로 변경됨',
    dialogChangedTimeSet: '예약 시간이 {0}으로 설정됨',
    dialogChangedTimeCleared: '예약 시간 제거됨 (최대한 빨리)',
    timeChangedLabel: '시간 변경됨',
    timeChangedToLabel: '변경된 시간',
    confirmChangeToDelivery: '배달로 변경하시겠습니까?',
    confirmChangeToPickup: '픽업으로 변경하시겠습니까?',
    confirmChangeTypeBody: '그룹의 모든 사람을 위한 주문 유형이 업데이트됩니다.',
    asap: '최대한 빨리',
    orderAsap: '최대한 빨리 주문',
    now: '지금',
    staleTimeTitle: '선택하신 시간을 더 이상 이용할 수 없습니다',
    staleTimeNearestSlotLabel: '가장 가까운 이용 가능 시간',
    staleTimeChooseAnother: '다른 시간 선택',
    errorResetSchedule: '시간 업데이트에 실패했습니다. 다시 시도해 주세요.',
    errorUpdateSchedule: '시간 업데이트에 실패했습니다. 다시 시도해 주세요.',
    errorUpdateScheduleConflict: '지금은 업데이트할 수 없습니다. 확인 후 다시 시도해 주세요.',
    discountsAtCheckout: '결제 시 할인 적용',
    deliveryFeeAtCheckout: '결제 시 계산',
    feesCalculatedAtCheckout: '세금, 수수료 및 할인은 결제 시 계산됩니다',
    exceedsSpendingLimit: '이 항목은 호스트가 설정한 지출 한도를 초과합니다.',
    cartFinalized: '단체 주문이 확정되었습니다. 더 이상 항목을 추가할 수 없습니다.',
    noDeadlineSlots: '마감 시간을 설정할 수 있는 시간대가 없습니다.',
    errorUpdateDeadline: '마감 시간을 업데이트할 수 없습니다. 다시 시도해 주세요.',
    deadlineUpdated: '주문 마감 시간이 업데이트되었습니다: {0}',
    deadlineRemoved: '주문 마감 시간이 업데이트되었습니다.',
    shareGroupOrder: '단체 주문에 참여하세요!',
    memberLocked: '잠금',
    snackParticipantLeftHost: '{0}이(가) 단체 주문을 나갔습니다.',
    tooltipBadgeNew: '신규',
    tooltipTitle: '단체 주문 이용 방법',
    tooltipScene1Caption: '메뉴 페이지에서 단체 주문을 시작하세요',
    tooltipScene2Caption: '마감 시간과 결제자를 설정하세요',
    tooltipScene3Caption: '링크를 공유하거나 친구가 QR 코드를 스캔해 참여하게 하세요',
    tooltipScene4Caption: '모두 하나의 장바구니에 추가합니다. 결제는 한 번만.',
    tooltipStartBtn: '단체 주문 시작하기',
    tooltipGotItBtn: '확인',
    tooltipDemoPeopleJoined: '{0}명 참여함',
    tooltipDemoDeadlineTimeExample: '7월 10일 (금) · 오후 12:30',
    tooltipDemoPaySub: '본인 결제 · 1인당 $15 한도',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: '그룹 장바구니',
    tooltipDemoOneCheckout: '결제는 한 번 — 본인이 결제',
    sheetTitle: '단체 주문이 새롭게 추가되었어요',
    sheetSubtitle: '함께 주문하세요 — 하나의 공유 장바구니, 한 번의 결제.',
    sheetBullet1: '주문 마감 시간 설정',
    sheetBullet2: '본인이 결제 — 또는 지출 한도 설정',
    sheetBullet3: '링크나 QR 코드로 초대',
    sheetNotNowBtn: '나중에',
    showHowItWorks: '작동 방식 보기',
    hostSetsTip: '호스트인 당신이 전체 단체 주문의 팁을 설정합니다.',
    checkoutErrorGeneric: '결제에 실패했습니다. 다시 시도해 주세요.',
    checkoutErrorInvalidCart: '결제를 진행하기 전에 장바구니의 일부 항목을 확인해야 합니다.',
    checkoutErrorOutOfStock: '일부 항목은 더 이상 이용할 수 없습니다. 삭제 후 다시 시도해 주세요.',
    checkoutErrorMissingSelection: '장바구니 항목의 선택 사항을 확인해 주세요.',
    checkoutErrorInvalidItem: '장바구니의 항목이 더 이상 유효하지 않습니다. 삭제 후 다시 시도해 주세요.',
    checkoutErrorPaymentDeclined: '카드가 거절되었습니다. 다른 결제 수단을 시도해 주세요.',
    checkoutErrorPaymentFraud: '카드 발급사가 이 결제 수단을 거절했습니다. 다른 결제 수단을 시도해 주세요.',
    checkoutErrorCardDetails: '카드 정보에 문제가 있습니다. 확인 후 다시 시도해 주세요.',
    checkoutErrorCardExpired: '이 카드는 만료되었습니다. 다른 결제 수단을 시도해 주세요.',
    checkoutErrorPaymentGateway: '결제를 처리할 수 없습니다. 다시 시도해 주세요.',
    checkoutErrorNotOpen: '이 단체 주문은 더 이상 열려 있지 않습니다.',
    checkoutErrorVersionConflict: '결제 중 단체 주문이 변경되었습니다. 확인 후 다시 시도해 주세요.',
    checkoutErrorInProgress: '이미 결제가 진행 중입니다.',
    checkoutErrorEmpty: '단체 장바구니가 비어 있습니다.',
    checkoutErrorBlocked: '아직 준비되지 않은 참가자가 있습니다.',
  },
  weChat: {
    warning: '페이지를 종료하고 WeChat 스캐너를 사용하여 QR 코드를 스캔해 주세요',
    title: '테이블 번호 입력'
  },
  checkout: {
    addCoupon: '쿠폰 추가',
    couponCode: '쿠폰 코드',
    title: '주문 제출',
    description: '주문을 제출하시겠습니까?',
    confirmCancel: '아니오',
    confirmApprove: '예',
    onlinePay: '온라인 결제',
    weChatPay: 'WeChat 결제',
    unitNumber: '유닛 번호 (선택 사항)',
    primaryMethod: '결제',
    secondaryMethod: '두 번째 결제 수단',
    credits: '매장 지갑',
    orderHints: '예: 식이 제한 사항',
    deliveryHints: '예: 배달 후 벨을 눌러주세요, 현관 옆에 놓아주세요, 호출기 번호 등',
    deliveryOptions: '배달 옵션',
    deliveryInstructions: '배달 지침',
    orderDisposables: '수저, 빨대 등',
    deliveryDisposables: '일회용 수저',
    disposablesIncluded: '요청하지 않으면 포함되지 않습니다',
    noPaymentMethods: '사용 가능한 결제 옵션이 없습니다.<br>{0}에 문의해 주세요',
    billLoadError: '주문 총액을 불러오지 못했습니다. 다시 시도해 주세요.',
    applePayFailed: 'Apple Pay를 시작할 수 없습니다. 다시 시도하거나 다른 결제 수단을 선택해 주세요.',
    retry: '다시 시도',
    confirmDialog: {
      total: '총계',
      name: '매장 이름',
      location: '매장 위치',
      deliveryInfo: '배달 정보',
      deliveryAddress: '배달 주소',
      deliveryPhone: '배달 전화번호',
      scheduled: '예약 시간',
      pay: '결제',
      pickupTitle: '매장에서 픽업하시겠습니까?',
      pickupBody: '이 주문을 매장에서 픽업하는 것을 확인해 주세요.',
      pickupTime: '픽업 시간:',
      beforeYouArrive: '방문 전 안내',
      yesPickUp: '네, 픽업할게요',
      goBack: '돌아가기'
    },
    deliveryMessage: {
      leave_at_door: '문 앞에 놓아주세요',
      meet_at_door: '문 앞에서 만나기',
      meet_outside: '외부에서 만나기'
    },
    couponTypes: {
      title: '쿠폰이 결제 옵션을 제한합니다:',
      membership: '매장 지갑',
      online: '신용카드',
      wechat: 'WeChat',
      offline: '현장 결제'
    }
  },
  qr: {
    manulInput: '스캐너가 작동하지 않나요? 테이블 번호를 입력해 주세요.',
    selectTable: '테이블 번호',
    select: '확인'
  },
  apps: {
    giftcard: '기프트 카드',
    coupons: '쿠폰 구매',
    deposit: '충전하기',
    lineup: '대기 명단',
    reservation: '예약'
  },
  requestService: {
    openButton: '서비스 요청',
    title: '서버에게 요청하기',
    sent: '요청이 전송되었습니다',
    login: '이 기능을 사용하려면 로그인해야 합니다',
    tableNeeded: '이 기능을 사용하려면 테이블 번호를 설정해 주세요'
  },
  sharedCart: {
    bannerLabel: '공유 테이블 · 테이블 #{0}',
    live: '실시간',
    staleItemWarning: '다른 손님이 업데이트했습니다 — 저장 전에 확인하세요',
    sentToKitchen: '주방으로 전송됨',
    roundSentToKitchen: '{0}차 · 주방으로 전송됨',
    alreadyOrdered: '주문 완료',
    itemCount: '{0}개',
    stillOrdering: '지금 추가 중',
    sending: '전송 중...',
    reconnected: '공유 테이블 {0}에 재연결되었습니다.',
    joinedTitle: '테이블에 참여했습니다!',
    joinedBody: '이제 이 테이블의 주문을 다른 모든 사람과 공유합니다.',
    completedTitle: '테이블 주문 결제 완료!',
    completedBody: '이 테이블의 결제가 완료되었습니다. 감사합니다!',
    billAtPosTitle: '계산서가 카운터로 전송되었습니다',
    billAtPosBody: '테이블 계산서가 카운터로 전송되었습니다. 주문을 완료하려면 그곳에서 결제해 주세요.',
    cancelledTitle: '테이블 세션 종료',
    cancelledBody: '이 테이블의 공유 장바구니 세션이 만료되었습니다. QR 코드를 스캔하여 새 세션을 시작하세요.',
    roundFired: '메뉴가 주방으로 전송되었습니다.',
    errorFireRound: '주방 전송에 실패했습니다. 다시 시도해 주세요.',
    errorItemChanged: '다른 사람이 이미 이 항목을 변경했습니다 — 최신 버전으로 새로고침되었습니다. 다시 시도해 주세요.',
    errorMutateCart: '처리되지 않았습니다. 다시 시도해 주세요.',
    errorSessionClosed: '이 테이블은 이미 닫혔습니다.',
    sharedTable: '공유 테이블',
    sharedTableActive: '● 공유 테이블 활성화됨',
    tableLabel: '테이블 {0}',
    errorStartSharedTable: '공유 테이블을 시작할 수 없습니다. 다시 시도해 주세요.',
  },
};
